import add from 'date-fns/add'
import differenceInMinutes from 'date-fns/differenceInMinutes'
import intervalToDuration from 'date-fns/intervalToDuration'
import { SortOrder, SortAs } from '@ocean/types/dist/sort'
import { LoggerUtils, SortUtils, LocalizationUtils, DateUtils } from '@ocean/utils'
import {
  SimulatorTrainingScheduleSession,
  SimulatorTrainingSessionType,
  SimulatorTrainingScheduleSessionGroup,
} from 'modules/simulatorTrainings/common/types'

class ScheduleSessionsUtils {
  groupSessions(
    sessions: SimulatorTrainingScheduleSession[]
  ): SimulatorTrainingScheduleSessionGroup[] {
    let groupsObj: Record<string, SimulatorTrainingScheduleSession[]> = {}

    const sortedSessions = [...sessions].sort(
      SortUtils.sortByMultipleKeys(['startDate'], SortOrder.Ascending, SortAs.Date)
    )

    sortedSessions.forEach(session => {
      const localSessionStartDate = DateUtils.convertUTCDateToLocalDate(session.startDate)
      const groupDate = DateUtils.formatDateBy(localSessionStartDate, 'yyyy-MM-dd')
      if (groupsObj[groupDate]) {
        groupsObj[groupDate].push(session)
      } else {
        groupsObj[groupDate] = [session]
      }
    })

    return Object.keys(groupsObj).map(date => ({ date, sessions: groupsObj[date] }))
  }

  // Consider a day as 8 hours
  getSessionsDuration(sessions: SimulatorTrainingScheduleSession[]): string {
    if (!sessions?.length) return ''

    const DAY_HOURS_DURATION = 8
    const now = new Date()
    let accumulatorDate = now

    try {
      const simulatorSessions = sessions.filter(
        ({ type }) => type === SimulatorTrainingSessionType.SimulatorEnvironment
      )

      if (!simulatorSessions?.length) return ''

      simulatorSessions.forEach(({ startDate, endDate }) => {
        const interval = intervalToDuration({ start: new Date(startDate), end: new Date(endDate) })
        accumulatorDate = add(accumulatorDate, interval)
      })

      const totalMinutes = differenceInMinutes(accumulatorDate, now)
      const totalHours = totalMinutes / 60
      const minutes = totalMinutes % 60
      let days = Math.floor(totalHours / DAY_HOURS_DURATION)
      let hours = Math.floor(totalHours % DAY_HOURS_DURATION)

      if (minutes > 0 && minutes <= 30) {
        hours += 0.5
      } else if (minutes > 30) {
        hours += 1
      }

      if (days === 0) {
        return LocalizationUtils.localize('duration.hours', { count: hours }) || ''
      }

      if (!hours) {
        return LocalizationUtils.localize('duration.days', { count: days }) || ''
      }

      days += hours <= DAY_HOURS_DURATION / 2 ? 0.5 : 1

      return (
        LocalizationUtils.localize('duration.days', {
          count: days,
        }) || ''
      )
    } catch (e) {
      LoggerUtils.error('getSessionsDuration error', e)
      return ''
    }
  }
}

export default new ScheduleSessionsUtils()
